import { Order } from "pages/vendor/Orders/Orders"
import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Col,
  Form,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import { FormInput } from "components/Extra/FormInput"
import { useTranslation } from "react-i18next"
import { updateOrderStatus } from "../../../../store/orders/actions"

interface RejectedOrderModalProps {
  order: Order | null
  isOpen: boolean
  toggle: () => void
}

export const RejectedOrderModal: React.FC<RejectedOrderModalProps> = ({
  order,
  isOpen,
  toggle,
}) => {
  const [openAccordion, setOpenAccordion] = useState("0")
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const validation = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
    validateOnMount: true,
    initialValues: {
      rejectedReason: "",
    },
    validationSchema: Yup.object({
      rejectedReason: Yup.string().trim(),
    }),
    onSubmit: ({ rejectedReason }) => {
      if (!order) return

      // Reject order - update status to Rejected (statusId: 7)
      const statusData = {
        StatusId: 5,
        ActionId: 5,
        Notes: rejectedReason,
      }
      dispatch(updateOrderStatus(order.id, statusData, { push: () => {} }))

      validation.resetForm()
      toggle()
    },
  })

  useEffect(() => {
    validation.resetForm()
  }, [isOpen])

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle} tag="h3">
        <h4 className="text-capitalize fw-semibold font-size-24">
          {t("common_rejectedOrder")}
        </h4>
      </ModalHeader>
      <ModalBody>
        <Form
          onSubmit={e => {
            e.preventDefault()
            validation.handleSubmit()
            return false
          }}
        >
          <Accordion open={openAccordion}>
            <AccordionItem>
              <AccordionHeader
                targetId="0"
                onClick={() =>
                  setOpenAccordion(openAccordion === "0" ? "1" : "0")
                }
              >
                {t("orders_rejectedInfo")}
              </AccordionHeader>
              <AccordionBody accordionId="0">
                <FormInput
                  label={t("orders_rejectReason") as string}
                  name="rejectedReason"
                  type="textarea"
                  placeholder={t("orders_enterMessage") as string}
                  validation={validation}
                  rows="3"
                />
              </AccordionBody>
            </AccordionItem>
          </Accordion>
          <Row>
            <Col>
              <div className="d-flex justify-content-end gap-2 mt-4">
                <button
                  type="submit"
                  className={`btn btn-primary save-customer`}
                  disabled={!(validation.isValid && validation.dirty)}
                >
                  {t("common_send")}
                </button>
                <button
                  onClick={toggle}
                  type="button"
                  className="btn btn-cancel text-primary border border-primary"
                >
                  {t("common_cancel")}
                </button>
              </div>
            </Col>
          </Row>
        </Form>
      </ModalBody>
    </Modal>
  )
}
